import _defineProperty from "@babel/runtime/helpers/defineProperty";

/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Button } from "@components/atoms";
import { accountUrl, baseUrl } from "@temp/app/routes";
import React from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { TextField } from "../TextField";
import * as S from "./styles";
import { commonMessages } from "../../../../intl";
export var ResetPasswordForm = function ResetPasswordForm(_ref) {
  var handleBlur = _ref.handleBlur,
      handleChange = _ref.handleChange,
      handleSubmit = _ref.handleSubmit,
      values = _ref.values,
      tokenError = _ref.tokenError,
      passwordError = _ref.passwordError,
      errors = _ref.errors,
      validPassword = _ref.validPassword;
  var intl = useIntl();
  return React.createElement(S.Wrapper, null, !validPassword ? React.createElement(React.Fragment, null, React.createElement("h3", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Reset password",
    "id": "@next.components.molecules.ResetPasswordForm.ResetPasswordForm.2925394684"
  }, "id", "@next.components.molecules.ResetPasswordForm.ResetPasswordForm.2925394684"))), React.createElement("p", null, intl.formatMessage(_defineProperty({
    defaultMessage: "Choose a new password for your account",
    "id": "@next.components.molecules.ResetPasswordForm.ResetPasswordForm.1712957873"
  }, "id", "@next.components.molecules.ResetPasswordForm.ResetPasswordForm.1712957873"))), tokenError && React.createElement(S.GeneralError, null, intl.formatMessage(_defineProperty({
    defaultMessage: "It seems that token for password reset is not valid anymore.",
    "id": "@next.components.molecules.ResetPasswordForm.ResetPasswordForm.2746979176"
  }, "id", "@next.components.molecules.ResetPasswordForm.ResetPasswordForm.2746979176"))), React.createElement("form", {
    onSubmit: handleSubmit
  }, React.createElement(S.InputFields, null, React.createElement(TextField, {
    label: intl.formatMessage(commonMessages.password),
    name: "password",
    onBlur: handleBlur,
    onChange: handleChange,
    type: "password",
    value: values.password,
    errors: errors.password || passwordError ? [{
      field: "password",
      message: errors.password || passwordError
    }] : undefined
  }), React.createElement(TextField, {
    label: intl.formatMessage(_defineProperty({
      defaultMessage: "Confirm password",
      "id": "@next.components.molecules.ResetPasswordForm.ResetPasswordForm.4056924605"
    }, "id", "@next.components.molecules.ResetPasswordForm.ResetPasswordForm.4056924605")),
    onBlur: handleBlur,
    name: "retypedPassword",
    onChange: handleChange,
    type: "password",
    value: values.retypedPassword,
    errors: errors.retypedPassword ? [{
      field: "retypedPassword",
      message: errors.retypedPassword
    }] : undefined
  })), React.createElement(Button, {
    type: "submit",
    fullWidth: true
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "SEND",
    "id": "@next.components.molecules.ResetPasswordForm.ResetPasswordForm.965956767"
  }, "id", "@next.components.molecules.ResetPasswordForm.ResetPasswordForm.965956767"))))) : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "register-confirm"
  }, React.createElement("div", {
    className: "account-confirm"
  }, React.createElement("h4", {
    className: "account-confirm__title"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Success!",
    "id": "@next.components.molecules.ResetPasswordForm.ResetPasswordForm.1523594272"
  }, "id", "@next.components.molecules.ResetPasswordForm.ResetPasswordForm.1523594272"))), React.createElement("p", {
    className: "account-confirm__text"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Your password had been successfully changed.",
    "id": "@next.components.molecules.ResetPasswordForm.ResetPasswordForm.1677526175"
  }, "id", "@next.components.molecules.ResetPasswordForm.ResetPasswordForm.1677526175"))), React.createElement("div", {
    className: "account-confirm__content"
  }, React.createElement(Link, {
    to: baseUrl
  }, React.createElement(Button, {
    className: "button red",
    type: "button"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "go to homepage",
    "id": "@next.components.molecules.ResetPasswordForm.ResetPasswordForm.788127442"
  }, "id", "@next.components.molecules.ResetPasswordForm.ResetPasswordForm.788127442")))), React.createElement(Link, {
    to: accountUrl
  }, React.createElement(Button, {
    className: "button white",
    type: "button"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "go to your account",
    "id": "@next.components.molecules.ResetPasswordForm.ResetPasswordForm.3287250114"
  }, "id", "@next.components.molecules.ResetPasswordForm.ResetPasswordForm.3287250114")))))))));
};